import { isTestEnv, isPreReleaseEnv, isMobile, isAndroid, isIOS, isWxwork } from './../web-tools/utils/util';

/**
 * 根据域名判断当前域名是在 “国内” 还是在 “国外VooV域名”
 *
 * @returns {String} is_overseas: 'yes' or 'no';
 */
export const isOverseasByDomainName = () => {
  if ( // “国外VooV域名”
    window.location.origin.indexOf('voovmeeting.com') > -1
  ) {
    return 'yes';
  }

  return 'no';
};

/**
 * 跳转到VooV Meeting下载链接
 */
export const downloadVooVMeeting = () => {

  const iosWxworkDownlaod = () => {
    return document.getElementById('android-download-guide-launch').style.display = '';
  }

  const iosUnWxworkDownlaod = () => {
    return location.href = 'https://apps.apple.com/app/tencent-meeting/id1497685373';
  }

  const androidDownload = () => {
    return location.href = 'https://play.google.com/store/apps/details?id=com.tencent.voov';
  }

  const pcTestDownload = () => {
    return location.href = 'https://test.web.voovmeeting.com/download-center.html?from=1001';
  }

  const pcNormalDownload = () => {
    return location.href = 'https://voovmeeting.com/download-center.html?from=1001';
  }

  const iosDownload = () => {
    if (!isIOS()) {
      return;
    }
    if (isWxwork()) {
      return iosWxworkDownlaod()
    } else {
      return iosUnWxworkDownlaod();
    }
  }

  const mobileDownload = () => {
    if (isAndroid()) {
      return androidDownload();
    } else {
      return iosDownload();
    }
  }

  const pcDownload = () => {
    if (isTestEnv()) {
      return pcTestDownload();
    } else {
      return pcNormalDownload();
    }
  }

  if (isMobile()) {
    return mobileDownload();
  } else {
    return pcDownload();
  }
};

/**
 * 跳转到Tencent Meeting下载链接
 */
export const downloadTencentMeeting = () => {
  let meetingOrigin = 'https://meeting.tencent.com';
  if (isTestEnv()) {
    meetingOrigin = 'https://test-3.txmeeting.tencent.com/';
  } else if (isPreReleaseEnv()) {
    meetingOrigin = 'https://pre.txmeeting.tencent.com';
  }

  if (isMobile()) { // 移动端下载
    if (isAndroid()) {
      const ua = navigator.userAgent;
      if (/mqqbrowser/i.test(ua) && /micromessenger/i.test(ua) && !(/wxwork/i.test(ua))) {
        window.history.pushState({ url: `${meetingOrigin}/` }, document.title, './download-android.html?from=1002');
        document.getElementById('android-download-guide-launch').style.display = '';
      } else {
        location.href = `${meetingOrigin}./download-android.html?from=1002`;
      }
    } else {
      if (isIOS()) {
        if (isWxwork()) {
          document.getElementById('android-download-guide-launch').style.display = '';
        } else {
          location.href = 'https://itunes.apple.com/cn/app/id1484048379';
        }
      }
    }
  } else { // PC 端下载
    location.href = `${meetingOrigin}/download-center.html?from=1002`;
  }
};
